
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as SeedIconComponent } from "./seed-icon.svg";

export const SeedIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <SeedIconComponent {...props} />;
};
